<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMH">CONTENTS</p>
<p class="CFMH"><span href="#/xhtml/title" title="Link target outside of Sample">Title Page</span></p>
<p class="CFMH"><span href="#/xhtml/copyrightnotice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="CFMH1"><a href="#/xhtml/introduction">Introduction: The Queen</a></p>
<p class="CCST"><span class="ePub-I">What neurologists do</span></p>
<p class="CCT"><span class="ccn">1.</span>   <a href="#/xhtml/chapter1#ch1">Six Improbable Things Before Breakfast</a></p>
<p class="CCST"><span class="ePub-I">Arrivals, departures, and delays on the ward</span></p>
<p class="CCT"><span class="ccn">2.</span>   <span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample">Like a Hole in the Head</span></p>
<p class="CCST"><span class="ePub-I">Where baseball and neurology converge in a game-saving, over-the-shoulder catch</span></p>
<p class="CCT"><span class="ccn">3.</span>   <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">The State of Confusion</span></p>
<p class="CCST"><span class="ePub-I">Two characters in search of a neurologist</span></p>
<p class="CCT"><span class="ccn">4.</span>   <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">My Man Godfrey</span></p>
<p class="CCST"><span class="ePub-I">A poor sort of memory that only works backwards</span></p>
<p class="CCT"><span class="ccn">5.</span>   <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">What Seems to Be the Problem?</span></p>
<p class="CCST"><span class="ePub-I">A politically incorrect guide to malingering, shamming, and hysteria</span></p>
<p class="CCT"><span class="ccn">6.</span>   <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Do No Harm</span></p>
<p class="CCST"><span class="ePub-I">A walking time bomb tests the limits of good sense</span></p>
<p class="CCT"><span class="ccn">7.</span>   <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">A Story Is Worth a Thousand Pictures</span></p>
<p class="CCST"><span class="ePub-I">Nine songs of innocence and experience</span></p>
<p class="CCT"><span class="ccn">8.</span>   <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Endgame</span></p>
<p class="CCST"><span class="ePub-I">Facing down Lou Gehrig’s disease</span></p>
<p class="CCT"><span class="ccn">9.</span>   <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">The Examined Life</span></p>
<p class="CCST"><span class="ePub-I">What it takes to survive a motor-neuron death sentence</span></p>
<p class="CCT"><span class="ccn">10.</span> <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">The Curse of the Werewolf</span></p>
<p class="CCST"><span class="ePub-I">On the front lines in the battle against Dr. Parkinson’s disease</span></p>
<p class="CCT"><span class="ccn">11.</span> <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">For the Want of a Nail</span></p>
<p class="CCST"><span class="ePub-I">A hard-knock lesson on the way to the morgue</span></p>
<p class="CCT"><span class="ccn">12.</span> <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">The Eyes Have It</span></p>
<p class="CCST"><span class="ePub-I">When is somebody not dead yet?</span></p>
<p class="CCT"><span class="ccn">13.</span> <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Boats Against the Current</span></p>
<p class="CCST"><span class="ePub-I">Based on a true story</span></p>
<p class="CBMH1"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="CBMH"><span href="#/xhtml/adcard" title="Link target outside of Sample">Also by Dr. Allan H. Ropper and Brian David Burrell</span></p>
<p class="CBMH"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample">About the Authors</span></p>
<p class="CBMH"><span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?33529028